import { Box, styled } from '@mui/system';

import { BOTTOM_NAVIGATION_HEIGHT } from '../BottomNavigation';
import { HEADER_HEIGHT } from '../Header';

interface ContentWrapperStyledProps {
  hideDrawer?: boolean;
}

interface EnrollmentContentWrapperStyledProps {
  fullWidth?: boolean;
}

export const PageLayoutWrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const ContentWrapperStyled = styled(Box)<ContentWrapperStyledProps>(
  ({ theme, hideDrawer }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: `calc(100vh - ${BOTTOM_NAVIGATION_HEIGHT} - ${HEADER_HEIGHT})`,
    '@supports (height: 100dvh)': {
      minHeight: `calc(100dvh - ${BOTTOM_NAVIGATION_HEIGHT} - ${HEADER_HEIGHT})`,
    },
    // phone
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      paddingTop: '0',
    },
    // tablet
    [theme.breakpoints.up('sm')]: {
      paddingTop: '11.2rem',
      width: '505px',
      margin: 'auto',
    },
    // desktop
    [theme.breakpoints.up('lg')]: {
      width: 920,
      paddingLeft: hideDrawer ? 124 : 250,
      // paddingRight: hideDrawer ? 117 : 0,
      paddingBottom: theme.spacing(6),
    },
  })
);

export const HomeContentWrapperStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  minHeight: `calc(100vh - 160px)`,
  paddingLeft: 0,
  paddingRight: 0,
  paddingTop: '60px',
  tabIndex: -1,
  '@supports (height: 100dvh)': {
    minHeight: `calc(100dvh - 160px)`,
  },
});

export const OrbitHeaderWrapperStyled = styled(Box)<ContentWrapperStyledProps>(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: `calc(100vh - ${BOTTOM_NAVIGATION_HEIGHT} - ${HEADER_HEIGHT})`,
    tabIndex: -1,
    '@supports (height: 100dvh)': {
      minHeight: `calc(100dvh - ${BOTTOM_NAVIGATION_HEIGHT} - ${HEADER_HEIGHT})`,
    },
    // phone
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4),
      paddingTop: '100px',
    },
    // tablet
    [theme.breakpoints.up('sm')]: {
      paddingTop: '11.2rem',
      width: '505px',
      margin: 'auto',
    },
    // desktop
    [theme.breakpoints.up('lg')]: {
      width: 670,
      paddingBottom: theme.spacing(6),
    },
  })
);

export const EnrollmentContentWrapperStyled = styled(
  Box
)<EnrollmentContentWrapperStyledProps>(({ fullWidth }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: `calc(100vh - 160px)`,
  position: 'relative',
  '@supports (height: 100dvh)': {
    minHeight: `calc(100dvh - 160px)`,
  },
  // adding padding for header and footer -- enrollment
  paddingBottom: '15rem',
  '@media (min-width: 1199px)': {
    paddingTop: '6.4rem',
  },
  '@media (min-width: 744px) and (max-width: 1199px)': {
    paddingTop: '56px',
    // paddingTop: '132px',
  },
  // full width formatting
  ...(fullWidth && {
    width: '100% !important',
    maxWidth: '100% !important',
  }),
}));

export const PublicContentWrapperStyled = styled(Box)(({ theme }) => ({
  height: '100vh',
  '@supports (height: 100dvh)': {
    height: '100dvh',
  },
  // tablet & phone
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(6),
  },
  [theme.breakpoints.up('sm')]: {
    paddingTop: '8rem',
  },
  // desktop
  [theme.breakpoints.up('lg')]: {
    width: 670,
    margin: 'auto',
    paddingBottom: theme.spacing(6),
  },
}));

export const DesktopChatBotStyling = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    display: 'none',
  },
}));
